module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/bucknell-university-f56edaa495cfabdaa4b71d2abdc3fc55.svg";